import produce from 'immer';

// import { formatDate } from 'utils/genericFunctions';
import { Types, enviaSMS } from './types';
import { ReducerAction } from '../../../../types';

export const INITIAL_STATE: enviaSMS = {
	status: 0,
	data: null,
};

export default function enviaSMSReducer(
	state = INITIAL_STATE,
	action: ReducerAction,
): enviaSMS {
	return produce(state, draft => {
		switch (action.type) {
			case Types.ENVIAR_SMS_REQUEST: {
				break;
			}
			case Types.ENVIAR_SMS_SUCCESS: {
				draft.data = action.payload.response.data;
				draft.status = action.payload.response.status;
				break;
			}
			case Types.ENVIAR_SMS_FAILURE: {
				draft.status = INITIAL_STATE.status;
				break;
			}
			case Types.ENVIAR_SMS_CLEAR: {
				draft.data = INITIAL_STATE.data;
				draft.status = INITIAL_STATE.status;
				break;
			}
			default:
		}
	});
}
